import { render, staticRenderFns } from "./PWmatIntroduce.vue?vue&type=template&id=6dd24268&scoped=true&"
import script from "./PWmatIntroduce.vue?vue&type=script&lang=js&"
export * from "./PWmatIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./PWmatIntroduce.vue?vue&type=style&index=0&id=6dd24268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd24268",
  null
  
)

export default component.exports